// extracted by mini-css-extract-plugin
module.exports = {"logos-wrapper":"pricing_logos-wrapper__2ofSy"};